import React from 'react'
import background from '../assets/images/bg.png';

export default function AuthLayout({ children }) {
  return (
    <div
      style={{
        padding: '0',
        minHeight: '100vh',
        backgroundImage: `url(${background})`,
        backgroundPosition: 'center',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: 'flex',
        flexDirection: 'column'
      }}
    >{children}</div>
  )
}
